// import { memo, useEffect, useMemo, useRef, useState } from "react";
// import { HashLink as Link } from "react-router-hash-link";
// import vide1 from "../../../assets/video/updated0102 (1).mp4";
// import vide2 from "../../../assets/video/Azure A9032 (online-video-cutter.com).mp4";
// import poster1 from "../../../assets/images/hero/azure-hero-1.webp";
// import poster2 from "../../../assets/images/hero/azure-hero-2.webp";

// const SERVER_BASE_URL = "https://admin.monsinidress.com";

// const ArrowRightIcon = ({ className = "h-7 w-7" }) => (
// 	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" focusable="false">
// 		<path d="M5 12h14M13 6l6 6-6 6" />
// 	</svg>
// );

// function ExploreCollection({ latestYear = 2027 }) {
// 	const [apiData, setApiData] = useState([]);
// 	const [mediaEnabled, setMediaEnabled] = useState(false);
// 	const heroRequestedRef = useRef(false);

// 	const staticVideos = useMemo(
// 		() => [
// 			{
// 				_id: "azure-static-1",
// 				src: vide1,
// 				poster: poster1,
// 				text: "EXPLORE GOWNS",
// 				desc: "Discover the elegance and charm of our exclusive collection.",
// 			},
// 			{
// 				_id: "azure-static-2",
// 				src: vide2,
// 				poster: poster2,
// 				text: "EXPLORE GOWNS",
// 				desc: "Discover the elegance and charm of our exclusive collection.",
// 			},
// 		],
// 		[]
// 	);

// 	useEffect(() => {
// 		const enableMedia = () => setMediaEnabled(true);
// 		window.addEventListener("pointerdown", enableMedia, { once: true, passive: true });
// 		window.addEventListener("keydown", enableMedia, { once: true });
// 		window.addEventListener("scroll", enableMedia, { once: true, passive: true });
// 		window.addEventListener("touchstart", enableMedia, { once: true, passive: true });

// 		return () => {
// 			window.removeEventListener("pointerdown", enableMedia);
// 			window.removeEventListener("keydown", enableMedia);
// 			window.removeEventListener("scroll", enableMedia);
// 			window.removeEventListener("touchstart", enableMedia);
// 		};
// 	}, []);

// 	useEffect(() => {
// 		if (!mediaEnabled || heroRequestedRef.current) return undefined;
// 		heroRequestedRef.current = true;
// 		const controller = new AbortController();
// 		const timer = window.setTimeout(() => controller.abort(), 6000);

// 		const fetchData = async () => {
// 			try {
// 				const response = await fetch(`${SERVER_BASE_URL}/api/hero-section/brand`, {
// 					method: "POST",
// 					headers: { "Content-Type": "application/json" },
// 					body: JSON.stringify({ brand: "Azure" }),
// 					signal: controller.signal,
// 				});
// 				if (!response.ok) return;
// 				const result = await response.json();
// 				if (!Array.isArray(result?.data) || result.data.length === 0) return;

// 				const transformed = result.data.map((item, index) => ({
// 					_id: item._id || `api-${index}`,
// 					brand: item.brand || "Azure",
// 					transformedMedia: Array.isArray(item.media)
// 						? item.media.map((mediaItem) => ({
// 							...mediaItem,
// 							url: mediaItem?.url?.startsWith("http")
// 								? mediaItem.url
// 								: `${SERVER_BASE_URL}/${String(mediaItem?.url || "").replace(/^\/+/, "")}`,
// 						}))
// 						: [],
// 				}));
// 				setApiData(transformed);
// 			} catch {
// 				// Static local media remains available if the API is slow or unavailable.
// 			} finally {
// 				window.clearTimeout(timer);
// 			}
// 		};

// 		fetchData();
// 		return () => {
// 			window.clearTimeout(timer);
// 			controller.abort();
// 		};
// 	}, [mediaEnabled]);

// 	const displayData = apiData.length > 0 ? apiData.slice(0, 2) : staticVideos;

// 	return (
// 		<section className="mt-[220px] flex w-full flex-col items-center justify-center pb-20" aria-labelledby="azure-explore-title">
// 			<h1 id="azure-explore-title" className="sr-only">Azure featured gown collections</h1>
// 			<div className="grid w-full grid-cols-1 gap-5 px-4 md:grid-cols-2 md:px-10 xl:px-20 2xl:px-28">
// 				{displayData.map((item, index) => {
// 					const media = item.transformedMedia?.[0];
// 					const localFallback = staticVideos[index] || staticVideos[0];
// 					const poster = localFallback.poster;
// 					const videoSrc = media?.type === "video" ? media.url : item.src || localFallback.src;
// 					const imageSrc = media && media.type !== "video" ? media.url : null;
// 					const label = apiData.length > 0 ? `EXPLORE ${String(item.brand || "AZURE").toUpperCase()}` : localFallback.text;
// 					const description = apiData.length > 0 ? `Discover the latest ${item.brand || "Azure"} collection` : localFallback.desc;

// 					return (
// 						<article key={item._id || index} className="group relative h-[600px] w-full overflow-hidden md:h-[700px] xl:h-[700px] 2xl:h-[1000px]">
// 							{mediaEnabled && videoSrc ? (
// 								<video
// 									src={videoSrc}
// 									poster={poster}
// 									autoPlay
// 									loop
// 									muted
// 									playsInline
// 									preload="none"
// 									className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
// 								/>
// 							) : imageSrc && mediaEnabled ? (
// 								<img
// 									src={imageSrc}
// 									alt={`${item.brand || "Azure"} gown collection`}
// 									loading={index === 0 ? "eager" : "lazy"}
// 									fetchPriority={index === 0 ? "high" : "low"}
// 									decoding="async"
// 									width="720"
// 									height="1280"
// 									className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
// 								/>
// 							) : (
// 								<img
// 									src={poster}
// 									alt={`${index === 0 ? "Azure featured" : "Azure gown"} collection`}
// 									loading="eager"
// 									fetchPriority={index === 0 ? "high" : "low"}
// 									decoding="async"
// 									width="720"
// 									height="1272"
// 									className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
// 								/>
// 							)}

// 							<div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" aria-hidden="true" />
// 							<div className="absolute inset-0 flex flex-col items-center justify-end p-6 text-center">
// 								<Link
// 									to={`/prom/${latestYear || 2027}`}
// 									className="mb-3 flex items-center justify-center gap-2 rounded-full bg-[#1f4c94]/90 px-6 py-3 font-lora text-base font-semibold text-white transition hover:bg-[#173d78] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
// 								>
// 									{label}
// 									<ArrowRightIcon className="hidden h-7 w-7 md:block" />
// 								</Link>
// 								<p className="max-w-sm text-sm font-light leading-relaxed text-white">{description}</p>
// 							</div>
// 						</article>
// 					);
// 				})}
// 			</div>
// 		</section>
// 	);
// }

// export default memo(ExploreCollection);



import { memo, useEffect, useMemo, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

import vide1 from "../../../assets/video/updated0102 (1).mp4";
import vide2 from "../../../assets/video/Azure A9032 (online-video-cutter.com).mp4";

import poster1 from "../../../assets/images/hero/azure-hero-1.webp";
import poster2 from "../../../assets/images/hero/azure-hero-2.webp";

const SERVER_BASE_URL = "https://admin.monsinidress.com";

/* =========================================================
   ICON
========================================================= */

const ArrowRightIcon = ({ className = "h-7 w-7" }) => (
    <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
        focusable="false"
    >
        <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
);

/* =========================================================
   EXPLORE COLLECTION
========================================================= */

function ExploreCollection({ latestYear = 2027 }) {
    const [apiData, setApiData] = useState([]);

    /* =====================================================
       STATIC FALLBACK VIDEOS
    ===================================================== */

    const staticVideos = useMemo(
        () => [
            {
                _id: "azure-static-1",
                src: vide1,
                poster: poster1,
                text: "EXPLORE GOWNS",
                desc: "Discover the elegance and charm of our exclusive collection.",
            },
            {
                _id: "azure-static-2",
                src: vide2,
                poster: poster2,
                text: "EXPLORE GOWNS",
                desc: "Discover the elegance and charm of our exclusive collection.",
            },
        ],
        []
    );

    /* =====================================================
       FETCH HERO DATA
    ===================================================== */

    useEffect(() => {
        const controller = new AbortController();

        const timer = window.setTimeout(() => {
            controller.abort();
        }, 6000);

        const fetchData = async () => {
            try {
                const response = await fetch(
                    `${SERVER_BASE_URL}/api/hero-section/brand`,
                    {
                        method: "POST",

                        headers: {
                            "Content-Type": "application/json",
                        },

                        body: JSON.stringify({
                            brand: "Azure",
                        }),

                        signal: controller.signal,
                    }
                );

                if (!response.ok) {
                    return;
                }

                const result = await response.json();

                if (
                    !Array.isArray(result?.data) ||
                    result.data.length === 0
                ) {
                    return;
                }

                const transformed = result.data.map(
                    (item, index) => ({
                        _id: item._id || `api-${index}`,

                        brand: item.brand || "Azure",

                        transformedMedia: Array.isArray(item.media)
                            ? item.media.map((mediaItem) => {
                                  const mediaUrl =
                                      mediaItem?.url || "";

                                  return {
                                      ...mediaItem,

                                      url: mediaUrl.startsWith(
                                          "http"
                                      )
                                          ? mediaUrl
                                          : `${SERVER_BASE_URL}/${String(
                                                mediaUrl
                                            ).replace(/^\/+/, "")}`,
                                  };
                              })
                            : [],
                    })
                );

                setApiData(transformed);
            } catch (error) {
                if (error?.name !== "AbortError") {
                    console.error(
                        "Hero section request failed:",
                        error
                    );
                }

                // Local videos will remain visible
            } finally {
                window.clearTimeout(timer);
            }
        };

        fetchData();

        return () => {
            window.clearTimeout(timer);
            controller.abort();
        };
    }, []);

    /* =====================================================
       VIDEO AUTOPLAY HANDLER

       Helps ensure the video starts as soon as it is ready.
    ===================================================== */

    const handleVideoReady = (event) => {
        const video = event.currentTarget;

        // Required for browser autoplay policies
        video.muted = true;

        const playPromise = video.play();

        if (playPromise !== undefined) {
            playPromise.catch(() => {
                // Browser may temporarily delay autoplay.
                // The autoPlay attribute remains enabled.
            });
        }
    };

    /* =====================================================
       DISPLAY DATA
    ===================================================== */

    const displayData =
        apiData.length > 0
            ? apiData.slice(0, 2)
            : staticVideos;

    /* =====================================================
       RENDER
    ===================================================== */

    return (
        <section
            className="mt-[220px] flex w-full flex-col items-center justify-center pb-20"
            aria-labelledby="azure-explore-title"
        >
            <h1
                id="azure-explore-title"
                className="sr-only"
            >
                Azure featured gown collections
            </h1>

            <div className="grid w-full grid-cols-1 gap-5 px-4 md:grid-cols-2 md:px-10 xl:px-20 2xl:px-28">
                {displayData.map((item, index) => {
                    /* =====================================
                       MEDIA
                    ===================================== */

                    const media =
                        item.transformedMedia?.[0];

                    const localFallback =
                        staticVideos[index] ||
                        staticVideos[0];

                    const poster =
                        localFallback.poster;

                    /*
                     * If API gives us a video:
                     * use API video.
                     *
                     * If there is no API media:
                     * use local fallback video.
                     *
                     * If API gives us an image:
                     * do not replace it with local video.
                     */

                    const videoSrc =
                        media?.type === "video"
                            ? media.url
                            : !media
                              ? item.src ||
                                localFallback.src
                              : null;

                    const imageSrc =
                        media &&
                        media.type !== "video"
                            ? media.url
                            : null;

                    /* =====================================
                       TEXT
                    ===================================== */

                    const label =
                        apiData.length > 0
                            ? `EXPLORE ${String(
                                  item.brand || "AZURE"
                              ).toUpperCase()}`
                            : localFallback.text;

                    const description =
                        apiData.length > 0
                            ? `Discover the latest ${
                                  item.brand || "Azure"
                              } collection`
                            : localFallback.desc;

                    return (
                        <article
                            key={item._id || index}
                            className="group relative h-[600px] w-full overflow-hidden md:h-[700px] xl:h-[700px] 2xl:h-[1000px]"
                        >
                            {/* =================================
                                VIDEO
                            ================================= */}

                            {videoSrc ? (
                                <video
                                    key={videoSrc}
                                    src={videoSrc}
                                    poster={poster}

                                    /* AUTOPLAY */
                                    autoPlay
                                    muted
                                    loop
                                    playsInline

                                    /*
                                     * First hero starts loading
                                     * immediately.
                                     *
                                     * Second video uses metadata
                                     * to reduce initial bandwidth.
                                     */
                                    preload={
                                        index === 0
                                            ? "auto"
                                            : "metadata"
                                    }

                                    onLoadedData={
                                        handleVideoReady
                                    }

                                    onCanPlay={
                                        handleVideoReady
                                    }

                                    disablePictureInPicture

                                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                                />
                            ) : imageSrc ? (
                                /* =============================
                                   API IMAGE
                                ============================= */

                                <img
                                    src={imageSrc}
                                    alt={`${
                                        item.brand ||
                                        "Azure"
                                    } gown collection`}
                                    loading={
                                        index === 0
                                            ? "eager"
                                            : "lazy"
                                    }
                                    fetchPriority={
                                        index === 0
                                            ? "high"
                                            : "high"
                                    }
                                    decoding="async"
                                    width="720"
                                    height="1280"
                                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                                />
                            ) : (
                                /* =============================
                                   POSTER FALLBACK
                                ============================= */

                                <img
                                    src={poster}
                                    alt={`${
                                        index === 0
                                            ? "Azure featured"
                                            : "Azure gown"
                                    } collection`}
                                    loading="eager"
                                    fetchPriority={
                                        index === 0
                                            ? "high"
                                            : "high"
                                    }
                                    decoding="async"
                                    width="720"
                                    height="1272"
                                    className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                                />
                            )}

                            {/* =================================
                                OVERLAY
                            ================================= */}

                            <div
                                className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"
                                aria-hidden="true"
                            />

                            {/* =================================
                                CONTENT
                            ================================= */}

                            <div className="absolute inset-0 flex flex-col items-center justify-end p-6 text-center">
                                <Link
                                    to={`/prom/${
                                        latestYear || 2027
                                    }`}
                                    className="mb-3 flex items-center justify-center gap-2 rounded-full bg-[#1f4c94]/90 px-6 py-3 font-lora text-base font-semibold text-white transition hover:bg-[#173d78] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
                                >
                                    {label}

                                    <ArrowRightIcon className="hidden h-7 w-7 md:block" />
                                </Link>

                                <p className="max-w-sm text-sm font-light leading-relaxed text-white">
                                    {description}
                                </p>
                            </div>
                        </article>
                    );
                })}
            </div>
        </section>
    );
}

export default memo(ExploreCollection);